import React from 'react'
import "./sectionAwards.scss"

//Imagens:
import ImgSectionAwards from "../../../assets/awards/sectionAwards.png"
import { t } from 'i18next'

function SectionAwards() {
  return (
    <div className='container-section-awards'>
        <div className='img-section-awards'>
            <img src={ImgSectionAwards} alt="" />
        </div>
        <div className='texts-section-awards'>
            <h1>{t("awards.title")}</h1>
            <p>{t("awards.section_text")}</p>
        </div>
    </div>
  )
}

export default SectionAwards